module.exports = __webpack_public_path__ + "static/media/kerry-logistikus-logo.24eb7dc3.png";